import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// 以下为语言包单独设置的场景，单独设置时语言包需单独引入
const messages = {
  'zh_CN': require('../assets/i18n/cn'),   // 简体语言包
  'zh_TW': require('../assets/i18n/tw')    // 繁体语言包
}

// 最后 export default，这一步肯定要写的。
export default new VueI18n({
  locale:localStorage.getItem('locale') || 'zh_CN',
  messages:messages
})


// WEBPACK FOOTER //
// ./src/tools/i18n.js